import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Alert from '@/components/shared/Alert';
import FormInput from '@/components/shared/form-input/FormInput';
import LocationGroupSelect from '@/components/shared/LocationGroupSelect';
import ModalIconButton from '@/components/shared/ModalIconButton';
import { SearchFilter } from '@/services/ResourceService';
export default {
  name: 'CreateSearchFilterModal',
  components: {
    Alert: Alert,
    FormInput: FormInput,
    LocationGroupSelect: LocationGroupSelect,
    ModalIconButton: ModalIconButton
  },
  data: function data() {
    return {
      isLoading: false,
      errorOccurred: false,
      name: null,
      locationIds: null,
      locationGroupIds: null
    };
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    if (this.data) {
      this.locationIds = this.data.locationIds;
      this.locationGroupIds = this.data.locationGroupIds;
    }
  },
  computed: {
    isValid: function isValid() {
      var _this$locationIds, _this$locationGroupId;
      if (this.name === null) {
        return false;
      }
      return this.name.trim().length > 0 && (((_this$locationIds = this.locationIds) === null || _this$locationIds === void 0 ? void 0 : _this$locationIds.length) > 0 || ((_this$locationGroupId = this.locationGroupIds) === null || _this$locationGroupId === void 0 ? void 0 : _this$locationGroupId.length) > 0);
    },
    preselectedIds: function preselectedIds() {
      var _this$data, _this$data2;
      return {
        locations: (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.locationIds,
        locationGroups: (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.locationGroupIds
      };
    }
  },
  methods: {
    createSearchFilter: function createSearchFilter() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dto;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.isLoading = true;
              _this.errorOccurred = false;
              dto = {
                name: _this.name.trim(),
                locationIds: _this.locationIds,
                locationGroupIds: _this.locationGroupIds
              };
              _context.prev = 3;
              _context.next = 6;
              return SearchFilter.createNewSearchFilter(_this.$store.state.general.selectedUser.id, dto);
            case 6:
              _this.isLoading = false;
              _this.$toasted.global.success(_this.$t('successfullyCreatedToast'));
              _this.$vuedals.close({
                refresh: true
              });
              _context.next = 15;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              _this.errorOccurred = true;
              _this.isLoading = false;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 11]]);
      }))();
    },
    locationsChanged: function locationsChanged(newLocationsAndGroups) {
      this.locationIds = newLocationsAndGroups.locations;
      this.locationGroupIds = newLocationsAndGroups.locationGroups;
    },
    closeModal: function closeModal() {
      this.$vuedals.close();
    }
  }
};